import { Eyebrow, Reveal } from "./Reveal";
import { images, PRIMARY_CTA_URL } from "../data/business";

export default function Courses() {
    return (
        <section
            data-testid="courses-section"
            className="border-y border-line bg-cream py-20 sm:py-28 lg:py-36"
        >
            <div className="mx-auto grid max-w-7xl grid-cols-1 items-center gap-12 px-4 sm:px-8 lg:grid-cols-12 lg:gap-16 lg:px-16">
                <div className="lg:col-span-6">
                    <Eyebrow>Cursos</Eyebrow>
                    <Reveal delay={0.1}>
                        <h2 className="mt-5 font-display text-3xl font-medium uppercase leading-[1.1] tracking-tight text-ink sm:text-4xl lg:text-5xl">
                            Da prática
                            <br />
                            <span className="italic text-accent">para a sala de aula.</span>
                        </h2>
                    </Reveal>
                    <Reveal delay={0.2}>
                        <p className="mt-6 max-w-md text-sm leading-relaxed text-ink-soft sm:text-base">
                            Além dos atendimentos, Danielly também compartilha seu
                            conhecimento em cursos presenciais para profissionais que
                            desejam desenvolver sua técnica.
                        </p>
                    </Reveal>
                    <Reveal delay={0.3}>
                        <a
                            href={PRIMARY_CTA_URL}
                            data-testid="courses-cta"
                            className="group mt-9 inline-flex items-center gap-3 bg-ink px-7 py-4 font-mono text-[11px] uppercase tracking-[0.2em] text-paper transition-colors duration-300 hover:bg-accent"
                        >
                            Quero conhecer os cursos
                            <span className="inline-block transition-transform duration-300 group-hover:translate-x-1">
                                →
                            </span>
                        </a>
                    </Reveal>
                </div>

                <Reveal delay={0.15} className="lg:col-span-6">
                    <div className="relative">
                        <div className="absolute -right-3 -top-3 h-full w-full border border-accent/40 sm:-right-5 sm:-top-5" />
                        <div className="relative overflow-hidden bg-cream">
                            <img
                                src={images.course}
                                alt="Danielly Sousa ministrando curso presencial no Studio Danielly Sousa"
                                loading="lazy"
                                className="aspect-[4/5] w-full object-cover"
                            />
                            <span className="absolute left-5 top-5 border border-paper/60 bg-ink/30 px-3 py-1.5 font-mono text-[9px] uppercase tracking-[0.25em] text-paper backdrop-blur-sm">
                                Turma presencial — foto real
                            </span>
                        </div>
                        <p className="mt-4 text-center font-mono text-[9px] uppercase tracking-[0.2em] text-ink-soft/70">
                            Danielly em aula no Studio — ensino com o mesmo cuidado do
                            atendimento
                        </p>
                    </div>
                </Reveal>
            </div>
        </section>
    );
}
